function somenteDigitos(valor) {
  return String(valor || '').replace(/\D/g, '');
}

export function validarCPF(cpf) {
  const digitos = somenteDigitos(cpf);
  if (digitos.length !== 11 || /^(\d)\1{10}$/.test(digitos)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i += 1) soma += parseInt(digitos.charAt(i), 10) * (10 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(digitos.charAt(9), 10)) return false;

  soma = 0;
  for (let i = 0; i < 10; i += 1) soma += parseInt(digitos.charAt(i), 10) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === parseInt(digitos.charAt(10), 10);
}

export function validarCNPJ(cnpj) {
  const digitos = somenteDigitos(cnpj);
  if (digitos.length !== 14 || /^(\d)\1{13}$/.test(digitos)) return false;

  let tamanho = digitos.length - 2;
  let numeros = digitos.substring(0, tamanho);
  let pos = tamanho - 7;
  let soma = 0;

  for (let i = tamanho; i >= 1; i -= 1) {
    soma += numeros.charAt(tamanho - i) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(tamanho), 10)) return false;

  tamanho += 1;
  numeros = digitos.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i -= 1) {
    soma += numeros.charAt(tamanho - i) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  return resultado === parseInt(digitos.charAt(tamanho), 10);
}

function semAcento(valor) {
  return String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

function recorteFavorecido(texto) {
  const norm = semAcento(texto);
  const inicios = ['beneficiario', 'cedente', 'emitente', 'prestador'];
  const fins = ['pagador', 'sacado', 'destinatario', 'tomador'];
  let inicio = -1;
  inicios.forEach((rotulo) => {
    const i = norm.indexOf(rotulo);
    if (i >= 0 && (inicio < 0 || i < inicio)) inicio = i;
  });
  const aPartir = inicio >= 0 ? inicio + 8 : 0;
  let fim = -1;
  fins.forEach((rotulo) => {
    const i = norm.indexOf(rotulo, aPartir);
    if (i >= 0 && (fim < 0 || i < fim)) fim = i;
  });
  if (inicio >= 0 && fim > inicio) return texto.slice(inicio, fim);
  if (inicio >= 0) return texto.slice(inicio);
  if (fim > 0) return texto.slice(0, fim);
  return texto;
}

function fazParteDeCodigoLongo(texto, index, tamanho) {
  let i = index;
  let j = index + tamanho;
  while (i > 0 && /[\d.\s/-]/.test(texto[i - 1])) i -= 1;
  while (j < texto.length && /[\d.\s/-]/.test(texto[j])) j += 1;
  return somenteDigitos(texto.slice(i, j)).length >= 20;
}

function documentosNoTexto(texto) {
  const cnpjs = [];
  const cpfs = [];
  const re = /\d[\d./-]{10,}\d/g;
  let encontrado;
  while ((encontrado = re.exec(texto)) !== null) {
    if (fazParteDeCodigoLongo(texto, encontrado.index, encontrado[0].length)) continue;
    const digitos = somenteDigitos(encontrado[0]);
    if (digitos.length === 14 && validarCNPJ(digitos) && !cnpjs.includes(digitos)) {
      cnpjs.push(digitos);
    } else if (digitos.length === 11 && validarCPF(digitos) && !cpfs.includes(digitos)) {
      cpfs.push(digitos);
    }
  }
  return {
    cnpj: cnpjs[0] || '',
    cpf: cpfs[0] || '',
  };
}

function limparNome(valor) {
  let nome = String(valor || '').replace(/\s+/g, ' ').trim();
  nome = nome.split(/\b(?:cnpj|cpf|endereco|e-mail|email|telefone|banco|pix)\b/i)[0].trim();
  nome = nome.replace(/^[\s:.\-/]+|[\s:.\-/]+$/g, '').trim();
  if (nome.length < 3 || nome.length > 120) return '';
  if (!/[A-Za-zÀ-ú]{3}/.test(nome)) return '';
  return nome;
}

function extrairNome(trecho) {
  const linhas = String(trecho || '').split(/\n/).map((linha) => linha.trim()).filter(Boolean);
  const rotulos = [
    'nome fantasia',
    'nome / razao social',
    'nome/razao social',
    'razao social',
    'beneficiario',
    'emitente',
    'prestador',
    'cedente',
  ];
  const normas = linhas.map(semAcento);
  for (let r = 0; r < rotulos.length; r += 1) {
    const rotulo = rotulos[r];
    for (let i = 0; i < linhas.length; i += 1) {
      const pos = normas[i].indexOf(rotulo);
      if (pos < 0) continue;
      const resto = limparNome(linhas[i].slice(pos + rotulo.length));
      if (resto) return resto;
      const proxima = limparNome(linhas[i + 1] || '');
      if (proxima && !rotulos.some((item) => semAcento(proxima).startsWith(item))) return proxima;
    }
  }
  return '';
}

function extrairEmail(trecho) {
  const encontrado = String(trecho || '').match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
  return encontrado ? encontrado[0] : '';
}

function extrairTelefones(trecho) {
  const re = /(?:\(?\d{2}\)?[\s.-]*)\d{4,5}[\s.-]?\d{4}/g;
  const achados = [];
  let encontrado;
  while ((encontrado = re.exec(trecho)) !== null) {
    if (fazParteDeCodigoLongo(trecho, encontrado.index, encontrado[0].length)) continue;
    const digitos = somenteDigitos(encontrado[0]);
    if (digitos.length < 10 || digitos.length > 13) continue;
    achados.push(encontrado[0].replace(/\s+/g, ' ').trim());
  }

  let telefone = '';
  let celular = '';
  achados.forEach((numero) => {
    let digitos = somenteDigitos(numero);
    if (digitos.startsWith('55') && digitos.length > 11) digitos = digitos.slice(2);
    const assinante = digitos.length >= 10 ? digitos.slice(2) : digitos;
    const ehCelular = assinante.length === 9 && assinante.startsWith('9');
    if (ehCelular && !celular) celular = numero;
    else if (!ehCelular && !telefone) telefone = numero;
  });
  return { telefone, celular };
}

function extrairBanco(texto) {
  const rotulo = String(texto || '').match(/\bbanco[^0-9\n]{0,30}(\d{3})\b/i);
  if (rotulo) return rotulo[1];

  const linha = String(texto || '').match(/(\d{5})\.?(\d{5})\s+(\d{5})\.?(\d{6})\s+(\d{5})\.?(\d{6})\s+(\d)\s+(\d{14})/);
  if (linha && !linha[1].startsWith('8')) return linha[1].slice(0, 3);

  const continuo = String(texto || '').match(/(?<!\d)(\d{47})(?!\d)/);
  if (continuo && !continuo[1].startsWith('8')) return continuo[1].slice(0, 3);
  return '';
}

function extrairAgenciaConta(texto) {
  const junto = String(texto || '').match(/ag[eê]ncia[^0-9]{0,60}?(\d{3,5})\s*\/\s*(\d{2,12})(?:\s*-\s*(\d))?/i);
  if (junto) {
    return {
      agencia: junto[1],
      conta: junto[3] ? `${junto[2]}-${junto[3]}` : junto[2],
    };
  }
  const agencia = String(texto || '').match(/ag[eê]ncia[^0-9]{0,40}(\d{3,5})\b/i);
  const conta = String(texto || '').match(/\bconta(?:\s+corrente)?[^0-9]{0,25}(\d{2,12})(?:\s*-\s*(\d))?/i);
  return {
    agencia: agencia ? agencia[1] : '',
    conta: conta ? (conta[2] ? `${conta[1]}-${conta[2]}` : conta[1]) : '',
  };
}

function extrairPix(texto) {
  const encontrado = String(texto || '').match(/\bpix\b[^A-Za-z0-9@+]{0,25}([A-Za-z0-9@.+_-]{5,77})/i);
  if (!encontrado) return '';
  const chave = encontrado[1].replace(/[.,;:]+$/, '');
  if (/^(copia|chave|codigo)$/i.test(chave)) return '';
  if (chave.startsWith('000201')) return '';
  return chave;
}

export function extrairDadosFavorecido(texto) {
  const bruto = String(texto || '');
  const trecho = recorteFavorecido(bruto);
  const docsTrecho = documentosNoTexto(trecho);
  const docsTexto = documentosNoTexto(bruto);
  const fones = extrairTelefones(trecho);
  const banco = extrairAgenciaConta(bruto);
  return {
    cnpj: docsTrecho.cnpj || docsTexto.cnpj,
    cpf: docsTrecho.cpf || docsTexto.cpf,
    nome: extrairNome(trecho),
    email: extrairEmail(trecho) || extrairEmail(bruto),
    telefone: fones.telefone,
    celular: fones.celular,
    banco: extrairBanco(bruto),
    agencia: banco.agencia,
    conta: banco.conta,
    pix: extrairPix(trecho) || extrairPix(bruto),
  };
}

function primeiroContato(valor, email) {
  if (valor == null) return '';
  const parte = String(valor)
    .split(/[/;,]/)
    .map((item) => item.trim())
    .find((item) => item && item.toLowerCase() !== 'null' && item !== '-');
  if (!parte) return '';
  if (email && !parte.includes('@')) return '';
  return parte;
}

export function completarLacunasComReceita(dados, receita) {
  const base = {
    nome: dados?.nome || '',
    email: dados?.email || '',
    telefone: dados?.telefone || '',
    consultou: false,
  };
  if (!receita || receita.status === 'ERROR') return base;

  const nomeApi = String(receita.fantasia || '').trim() || String(receita.nome || '').trim();
  return {
    nome: base.nome || nomeApi,
    email: base.email || primeiroContato(receita.email, true),
    telefone: base.telefone || primeiroContato(receita.telefone, false),
    consultou: true,
  };
}

export function sugerirTipoPix(chave, opcoes) {
  if (!chave || !Array.isArray(opcoes) || !opcoes.length) return null;
  const digitos = somenteDigitos(chave);
  let termos = ['aleat'];
  if (String(chave).includes('@')) termos = ['mail'];
  else if (digitos.length === 14 && validarCNPJ(digitos)) termos = ['cnpj'];
  else if (digitos.length === 11 && validarCPF(digitos)) termos = ['cpf'];
  else if (digitos.length >= 10 && digitos.length <= 13) termos = ['tel', 'cel', 'fone'];

  return opcoes.find((opcao) => {
    const rotulo = semAcento(opcao.label || '');
    return termos.some((termo) => rotulo.includes(termo));
  }) || null;
}

export { somenteDigitos };
